module.exports = __webpack_public_path__ + "static/media/google-play-btn.74179074.svg";